import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import { SbSharedSearchSuggestions } from '../SbSharedSearchSuggestions/SbSharedSearchSuggestions';
import { SbSharedTitle } from '../SbSharedTitle/SbSharedTitle';
import {
    FILTER_SEARCH,
    FILTER_REFINE_SEARCH,
} from '../SbSharedRefineMenu/sbSharedRefineMenuConstants';

// styles
import styles from './SbRespNullSearchResultsHeader.scss';

const shouldShowSearchHeader = appliedFilters => {
    return appliedFilters.some(
        ({ name }) => name === FILTER_SEARCH || name === FILTER_REFINE_SEARCH
    );
};

export const SbRespNullSearchResultsHeaderComponent = ({ searchTerm, itemSearch }) => {
    const { appliedFilters = [] } = itemSearch;
    return shouldShowSearchHeader(appliedFilters) ? (
        <div className={styles.container}>
            <div className={styles.results}>
                <FormattedMessage
                    id="sb.SbRespNullSearchResultsHeader.zeroResults"
                    defaultMessage={`0 results for "{searchTerm}"`}
                    values={{ searchTerm }}
                />
            </div>
            <SbSharedSearchSuggestions
                searchTerm={searchTerm}
                itemSearch={itemSearch}
                className={styles.searchSuggestions}
            />
        </div>
    ) : (
        <SbSharedTitle itemSearch={itemSearch} searchTerm={searchTerm} />
    );
};

SbRespNullSearchResultsHeaderComponent.propTypes = {
    searchTerm: PropTypes.string,
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespNullSearchResultsHeader = createFragmentContainer(
    SbRespNullSearchResultsHeaderComponent,
    {
        itemSearch: graphql`
            fragment SbRespNullSearchResultsHeader_itemSearch on ItemSearchQueryConnection {
                ...SbSharedSearchSuggestions_itemSearch
                ...SbSharedTitle_itemSearch
                appliedFilters {
                    name
                }
            }
        `,
    }
);
